export default "__VITE_ASSET__tWKZc59T__"